export default __webpack_public_path__ + "static/media/scribble.7cc40ff6.png";